import React from 'react'

import Details from '../details/Details'
import RelatedServiceOrdersList from '../relatedServiceOrders/RelatedServiceOrdersList'
import TriggerCallsList from '../triggerCallsList/TriggerCallsList'
import AuditList from '../audit/AuditList'

export const tabsOptions = [
  { translationKey: 'details', render: () => <Details /> },
  { translationKey: 'timeline', render: () => <RelatedServiceOrdersList /> },
  { translationKey: 'triggerEvents', render: () => <TriggerCallsList /> },
  { translationKey: 'audit', render: () => <AuditList /> }
]
